module.exports = __webpack_public_path__ + "static/Unity_Tower_upper_floor_4Tenants_v2-0120deacb87fb4dcc5cbac530c1c24e8.png";